<div class="wrapper ">
  <div id="formContent">

        <h3>Gracias por registrarse</h3>
  
        <div class="formGroup" >
          <p class="text-center">
            Hemos enviado un correo electrónico de confirmación a <strong></strong>.</p>
          <p class="text-center">Por favor revise su correo electrónico y haga clic en el enlace para verificar su dirección de correo electrónico.</p>
        </div>
        
        <!-- Calling SendVerificationMail() method using authService Api -->
        <div class="formGroup">
          <button type="button" class="btn btnPrimary"  style = "color: blue">
            <i class="fas fa-redo-alt"></i>
            Reenviar correo electrónico de verificación
          </button>
        </div>
  
      
      <div id="formFooter">
      <div class="redirectToLogin">
        <span>Volver a?</span><a class="redirect" routerLink="/sign-in"> Acceder</a> 
      </div>
    </div>

    </div>
  </div>


